export enum GlobalExport {
  Accounting = "Accounting",
  Ministry = "Ministry",
}
